import iconPath from '@/assets/device-icons/mac-pro.svg';

interface MacProIconProps {
  className?: string;
}

export const MacProIcon = ({ className = "h-5 w-5" }: MacProIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="Mac Pro" 
      className={className}
    />
  );
};
